import { Divider, Grid, Typography } from '@mui/material';
import React from 'react'
import FeatureCard from '../../pages/getStarted/components/featureCard'; 
import styles from "../../../assets/styles/componentStyles/getStartedStyles/getStartedStyles.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss"; 
import headerStyles from '../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'

interface GlobalEmptyPageProps {
    icon: any, 
    titleText: string,
} 

const GlobalEmptyPage: React.FC<GlobalEmptyPageProps> = (props) => {
    
    const { icon, titleText } = props;

    return (
        <> 
            <Grid container display={"flex"} gap={"12px"} direction={"column"} alignItems={"center"}>
                <Grid item xs={12}>
                    {icon}
                </Grid>
                <Grid item xs={12}>
                    <Typography className={styles.emptyPageTitleText}>
                        {titleText}
                    </Typography>
                </Grid>
                <Grid item xs={12} style={{  width: '50%'}}>
                    <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle}`}/>
                </Grid>
                <Grid item xs={12}>
                    <FeatureCard />
                </Grid>
            </Grid>
        </>
    )
}

export default GlobalEmptyPage
